<template>
  <div
    component-name="card-store-minimal"
    class="flex flex-col justify-between items-between gap-xl"
  >
    <div class="w-full">
      <header class="flex flex-col items-stretch w-full gap-2xs">
        <txt-heading size="small" :text="overline" class="w-full" />
        <wrapper-split-text reveal="chars" class="w-full">
          <div
            class="w-full text-skin-base text-heading-5"
            v-html="title"
          ></div>
        </wrapper-split-text>
      </header>

      <div
        v-if="address || tel || email || openingTime"
        class="flex flex-col items-stretch w-full text-skin-base gap-md"
      >
        <div v-if="address" class="flex flex-col">
          <wrapper-reveal reveal="fade-from-bottom" class="w-full">
            <div
              class="w-full text-skin-base text-overline/none"
              v-html="$t.labels.address"
            ></div>
          </wrapper-reveal>
          <wrapper-reveal reveal="fade-from-bottom" class="w-full">
            <div
              class="w-full text-skin-base text-body"
              v-html="finalAddress.title"
            ></div>
          </wrapper-reveal>
        </div>

        <div v-if="tel && telNumber" class="flex flex-col">
          <wrapper-reveal reveal="fade-from-bottom" class="w-full">
            <div
              class="w-full text-skin-base text-overline/none"
              v-html="$t.labels.tel"
            ></div>
          </wrapper-reveal>

          <wrapper-reveal reveal="fade-from-bottom" class="w-full">
            <btn
              :title="tel"
              :action="{ href: telNumber, tel: true }"
              class="inline-block truncate max-w-full text-skin-base text-body"
              >{{ tel }}</btn
            >
          </wrapper-reveal>
        </div>

        <div v-if="email" class="flex flex-col">
          <wrapper-reveal reveal="fade-from-bottom" class="w-full">
            <div
              class="w-full text-skin-base text-overline/none"
              v-html="$t.labels.email"
            ></div>
          </wrapper-reveal>
          <wrapper-reveal reveal="fade-from-bottom" class="w-full">
            <btn
              :title="email"
              :action="{ href: email, email: true }"
              class="inline-block truncate max-w-full text-skin-base text-body"
              >{{ email }}</btn
            >
          </wrapper-reveal>
        </div>

        <div v-if="openingTime" class="flex flex-col">
          <wrapper-reveal reveal="fade-from-bottom" class="w-full">
            <div
              class="w-full text-skin-base text-overline/none"
              v-html="$t.labels.opening_time"
            ></div>
          </wrapper-reveal>
          <wrapper-reveal reveal="fade-from-bottom" class="w-full">
            <div
              class="w-full text-skin-base text-body"
              v-html="openingTime"
            ></div>
          </wrapper-reveal>
        </div>
      </div>
    </div>

    <footer
      v-if="finalAddress?.href || website"
      class="flex flex-wrap gap-lg w-full"
    >
      <btn-pill
        v-if="finalAddress?.href"
        size="small"
        :title="$t.labels.get_directions"
        :action="{ href: finalAddress.href }"
        icon="store-locator"
      />

      <btn-pill
        v-if="website"
        size="small"
        :title="$t.labels.website"
        :action="{ href: website }"
        icon="url"
      />
    </footer>
  </div>
</template>

<script setup>
const props = defineProps({
  overline: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  address: {
    type: Object,
    required: true,
  },
  tel: {
    type: [String, Number],
    required: false,
  },
  email: {
    type: String,
    required: false,
  },
  openingTime: {
    type: String,
    required: false,
  },
  website: {
    type: String,
    required: false,
  },
  directions: {
    type: String,
    required: false,
  },
});

const telNumber = computed(() => {
  let n;

  if (props.tel) {
    n = props.tel.toString();
    n = n.replace(/\s+/g, "");
  }

  return n;
});

const finalAddress = computed(() => {
  if (!props.address) return null;

  const { street, postal_code, city, state_code, country } = props.address;

  let address = [];
  if (street) {
    address.push(street);
  }

  if (postal_code) {
    address.push(postal_code);
  }

  if (city) {
    address.push(state_code ? `${city} (${state_code})` : city);
  } else if (state_code) {
    address.push(state_code);
  }

  if (country) {
    address.push(country);
  }

  const final = address.join(", ");

  return {
    title: final,
    href: `https://www.google.com/maps/search/?api=1&query=${final}`,
  };
});
</script>
